export default __webpack_public_path__ + "static/media/logomob.ee323e32.png";